module.exports = __webpack_public_path__ + "images/category_lp/brand/store_images/1_a025d3c4b47bd920eaacaa9d46da2ec8.png";